import { __read } from "tslib";
import { useState } from 'react';
var useDynamicChartLayout = function (useDynamicLayout, initialMargins) {
    var _a = __read(useState(initialMargins), 2), layoutMargins = _a[0], setLayoutMargins = _a[1];
    var _b = __read(useState(!useDynamicLayout), 2), layoutReady = _b[0], setLayoutReady = _b[1];
    return {
        layoutReady: layoutReady,
        layoutMargins: layoutMargins,
        setLayoutReady: setLayoutReady,
        setLayoutMargins: setLayoutMargins,
    };
};
export default useDynamicChartLayout;
